// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';
// local
// css
import './MainMenu.scss';
// images
import logo from 'app/_assets/img/salvusatas_logo.png';
// menu
import { getMenu } from './routes';

function titleToClass(str) {
    return `ic_menu_${str.trim().toLowerCase()}`.replace(/[^\w]/g, '');
}

const MenuItem = props => {
    const classImage = titleToClass(props.title);
    return (
        <li>
            <NavLink to={props.path} exact={props.exact} title={props.title}>
                {props.image && <img src={props.image} alt={props.title} className={classImage} />}
                {props.title}
            </NavLink>
        </li>
    );
};

MenuItem.propTypes = {
    path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    exact: PropTypes.bool,
    icon: PropTypes.string,
    image: PropTypes.string,
};

class MainMenu extends Component {
    constructor(props) {
        super(props);
        this.menu = getMenu(props.account);
    }

    render() {
        return (
            <div id="main-menu">
                <div className="logo">
                    <img src={logo} alt="Salvus" />
                </div>
                <ul>{_.map(this.menu, item => <MenuItem key={`menu-${item.path}`} {...item} />)}</ul>
            </div>
        );
    }
}

MainMenu.propTypes = {
    account: PropTypes.object.isRequired,
};

export default MainMenu;
